import {NewsError} from './NewsError.js'

export class GetModelDetailNewsError extends NewsError {}
